/****************************************
    Custom Styles for Modal dialog
    @author  IMH003
    @date    2019.6.4
    @version 0.1    
 ******************************************/

export const stepEditStyle = {
    overlay : {
        backgroundColor: 'rgba(0,0,0,0.7)',
        zIndex : 101,
        WebkitAnimationName: 'my_fade',
        WebkitAnimationDuration: '700ms',
        animationName: 'my_fade',
        animationDuration: '700ms',
    },
    content : {
      top                   : '15%',
      left                  : '50%',
      right                 : 'auto',
      bottom                : 'auto',
      width                 : '60%',
      height                : '75%',
      minWidth              : '310px',
      padding               : '0px',
      transform             : 'translate(-50%, 0)'
    }
};
export const stepAlarmEditStyle = {
    overlay : {
        backgroundColor: 'rgba(0,0,0,0.7)',
        zIndex : 101,
        WebkitAnimationName: 'my_fade',
        WebkitAnimationDuration: '700ms',
        animationName: 'my_fade',
        animationDuration: '700ms',
    },
    content : {
      top                   : '4%',
      left                  : '50%',
      right                 : 'auto',
      bottom                : 'auto',
      width                 : '60%',
      height                : '90%',
      minWidth              : '310px',
      padding               : '0px',
      transform             : 'translate(-50%, 0)'
    }
};
export const adsStyle = {
    overlay : {
        backgroundColor: 'rgba(0,0,0,0.7)',
        zIndex : 101,
        WebkitAnimationName: 'my_fade',
        WebkitAnimationDuration: '700ms',
        animationName: 'my_fade',
        animationDuration: '700ms',
    },
    content : {        
        top                   : '10%',
        left                  : '50%',
        right                 : 'auto',
        bottom                : 'auto',
        width                 : '60%',
        height                : 'auto',
        maxHeight             : '85%',
        minWidth              : '310px',
        padding               : '0px',
        transform             : 'translate(-50%, 0)'
    }
};

export const RightBarStyle = {
    overlay : {
        backgroundColor: 'rgba(0,0,0,0.7)',
        zIndex : 99,
        WebkitAnimationName: 'my_fade',
        WebkitAnimationDuration: '700ms',
        animationName: 'my_fade',
        animationDuration: '700ms',
    },
    content : {
        top                   : '0',
        left                  : 'auto',
        right                 : '0',
        bottom                : 'auto',
        width                 : '450px',
        maxWidth              : '450px',
        height                : '100%',
        marginRight           : 'auto',
        borderRadius          : '0',
        overflow              : 'hidden',
        backgroundColor       : '#7c38bc',
        transform             : 'translate(0%, 0%)',      
        WebkitAnimationName: 'my_trans',
        WebkitAnimationDuration: '500ms',
        animationName: 'my_trans',
        animationDuration: '500ms',
    }
};
